/**
 * 序列化参数（jq 的 $.param() 源码）
 * @param {Object} data
 */
var r20 = /%20/g
var rbracket = /\[\]$/
const buildParams = function (prefix, obj, add) {
  var name;
  if (Array.isArray(obj)) {
    obj.forEach(function (v, i) {
      if (rbracket.test(prefix)) {
        add(prefix, v);
      } else {
        buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, add)
      }
    });
  } else if (typeof obj === 'object') {
    for (name in obj) {
      buildParams(prefix + '[' + name + ']', obj[name], add)
    }
  } else {
    add(prefix, obj)
  }
}

const handleParams = function (param) {
  var prefix
  var result = []
  var add = function (key, value) {
    value = (value == null ? '' : value)
    result[result.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value)
  }
  if (Array.isArray(param)) {
    param.forEach(function (p) {
      add(p.name, p.value)
    })
  } else {
    for (prefix in param) {
      buildParams(prefix, param[prefix], add)
    }
  }
  return result.join('&').replace(r20, '+')
}

export default function stringify(request) {
  request.data = handleParams(request.data)
  return request
}



// WEBPACK FOOTER //
// ./src/axios/request_interceptors/stringify_params.js